import { render, staticRenderFns } from "./LessonRow.vue?vue&type=template&id=2bc2ac4e&scoped=true&"
import script from "./LessonRow.vue?vue&type=script&lang=js&"
export * from "./LessonRow.vue?vue&type=script&lang=js&"
import style0 from "./LessonRow.vue?vue&type=style&index=0&id=2bc2ac4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc2ac4e",
  null
  
)

export default component.exports